<template>
    <div class="ops">
        <h1>Ops</h1>
        <c-form
            v-if="isSpexConfigurable"
            data-service-repository="stekStekMgtUpdateStekConfigurations"
            data-service-repository-for-prefill="stekStekMgtGetStekConfigurations"
            data-action="create"
        >
            <c-form-error-visualizer></c-form-error-visualizer>
            <c-form-input
                data-name="process_engine.type"
                data-type="choice"
                data-choices='[{"value":"SPEX","name":"Spex Engine"}]'
                data-label="Process Engine"
            ></c-form-input>
            <c-form-input
                data-name="process_engine.hostname"
                data-type="string"
                data-label="Process Engine hostname"
                data-placeholder="spex.dev.yourcompany.app"
            ></c-form-input>
            <c-form-button data-proxy-action="submit"></c-form-button>
        </c-form>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import {
    useAuthenticationManager,
    AuthStatus,
} from "@/stores/authentication-store";
import "@/wc/registry/component/form/index.js";
import "@/wc/registry/component/form-button/index.js";
import "@/wc/registry/component/form-error-visualizer/index.js";
import config from "@/config";

export default defineComponent({
    name: "Ops",
    setup() {
        const { authStatus } = useAuthenticationManager();
        return {
            // We should move the 'spex configuration' to a specific
            // 'ops instance' page. But for now it is hidden behind a feature
            // flag and an authentication check.
            isSpexConfigurable: computed(
                () =>
                    config.features.spex &&
                    authStatus.value === AuthStatus.SIGNED_IN
            ),
        };
    },
});
</script>
